import { useState } from 'react'

import { AddButton } from '#app/routes/mocra+/_form+/components/add-button.tsx'
import { AddressOverlay } from '#app/routes/mocra+/_form+/components/addresses/overlay.tsx'
import {
	createAddressDraft,
	type AddressDraft,
} from '#app/routes/mocra+/_form+/components/addresses/types.ts'

type Props = {
	readonly onSubmit: (draft: AddressDraft) => void
	readonly defaultValue?: AddressDraft
	readonly triggerLabel?: string
	readonly disabled?: boolean
	readonly className?: string
	readonly open?: boolean
	readonly onOpenChange?: (open: boolean) => void
}

export function AddressAdd({
	onSubmit,
	defaultValue,
	triggerLabel,
	disabled,
	className,
	open,
	onOpenChange,
}: Props) {
	const [uncontrolledOpen, setUncontrolledOpen] = useState(false)
	const isControlled = typeof open === 'boolean'
	const openState = isControlled ? open : uncontrolledOpen
	const setOpenState = (next: boolean) => {
		if (!isControlled) setUncontrolledOpen(next)
		onOpenChange?.(next)
	}

	const handleSubmit = (draft: AddressDraft) => {
		onSubmit(draft)
		setOpenState(false)
	}

	return (
		<>
			<AddButton
				onClick={() => setOpenState(true)}
				disabled={disabled}
				className={className}
			>
				{triggerLabel ?? 'Add address'}
			</AddButton>
			<AddressOverlay
				mode="add"
				open={openState}
				onOpenChange={setOpenState}
				onSubmit={handleSubmit}
				initialValue={defaultValue ?? createAddressDraft()}
				onClosed={() => setOpenState(false)}
			/>
		</>
	)
}
